import React from "react"
import clsx from "clsx"
import { dayNumber, isoWeek, parseISO, weekdayShort } from "../lib/dates"
import { dayTone } from "../lib/days"

const GridHeader = ({ days, template, firstLabel, density }) => (
  <div className="grid sticky top-0 z-[8] border-b border-slate-200" style={{ gridTemplateColumns: template }}>
    <div className="sticky left-0 z-[9] flex items-end px-3 pb-2 bg-white border-r border-slate-200">
      <span className="text-[10.5px] font-semibold uppercase tracking-wider text-slate-400">{firstLabel}</span>
    </div>
    {days.map((day, index) => {
      const monday = parseISO(day.date).getUTCDay() === 1
      return (
        <div
          key={day.date}
          title={day.holiday || undefined}
          className={clsx(
            "relative flex flex-col items-center justify-end gap-0.5 pt-2 pb-1.5 border-r border-slate-100 min-w-0",
            dayTone(day),
            monday && index > 0 && "border-l border-l-slate-200",
          )}
        >
          {monday && density !== "comfortable" && (
            <span className="absolute top-1 left-1.5 text-[9.5px] font-semibold text-slate-400">
              {I18n.t("project_planning.week_short", { number: isoWeek(day.date) })}
            </span>
          )}
          <span className={clsx("text-[10.5px] font-semibold uppercase tracking-wide", day.today ? "text-brand-600" : day.weekend ? "text-slate-400" : "text-slate-500")}>
            {weekdayShort(day.date)}
          </span>
          <span
            className={clsx(
              "grid place-items-center rounded-full tabular-nums font-semibold",
              density === "compact" ? "w-6 h-6 text-[12px]" : "w-7 h-7 text-[14px]",
              day.today ? "bg-brand-500 text-white" : day.weekend ? "text-slate-400" : "text-slate-800",
            )}
          >
            {dayNumber(day.date)}
          </span>
          {day.holiday && (
            <span className="max-w-full px-1 truncate text-[9.5px] font-medium text-amber-700">{day.holiday}</span>
          )}
        </div>
      )
    })}
    <div className="flex items-end justify-end px-3 pb-2 bg-white">
      <span className="text-[10.5px] font-semibold uppercase tracking-wider text-slate-400">{I18n.t("project_planning.total")}</span>
    </div>
  </div>
)

export default GridHeader
